const DEVICE_ID_COOKIE = 'device_id';

/**
 * Reads the first-party `device_id` cookie set server-side (see the app's
 * `hooks.server.ts`). Returns `undefined` when running outside the browser or
 * when the cookie is absent, which keeps every caller a safe no-op until the
 * cookie exists.
 */
export const getDeviceId = (): string | undefined => {
	if (typeof document === 'undefined') {
		return undefined;
	}

	return document.cookie
		.split('; ')
		.find((cookie) => cookie.startsWith(`${DEVICE_ID_COOKIE}=`))
		?.split('=')[1];
};
